export const mauIn = {
  titles: {
    list: 'Print templates',
    edit: 'Edit print template',
    hoaDon: 'Invoice print template',
  },
  subtitle: 'Each screen has its own templates and fields',
  screens: {
    title: 'Screens',
    groups: {
      giaoDich: 'Sales',
      soQuy: 'Cashbook',
      kho: 'Inventory',
      giaoHang: 'Delivery',
    },
    items: {
      'hoa-don': 'Invoice',
      'hoa-don-ycsc': 'Repair invoice',
      'tra-hang': 'Return',
      'dat-hang': 'Order',
      'yeu-cau-sua-chua': 'Repair',
      'phieu-thu': 'Receipt',
      'phieu-chi': 'Payment',
      'phieu-nhap-kho': 'In',
      'phieu-xuat-kho': 'Out',
      'chuyen-hang': 'Transfer',
      'phieu-nhan-hang': 'GRN',
      'kiem-ke': 'Stocktake',
      'tem-hang-hoa': 'Label',
      'nhan-giao-hang': 'Ship label',
    },
  },
  tabs: {
    pdf: 'PDF',
    excel: 'Excel',
  },
  sections: {
    header: 'Header',
    body: 'Invoice info',
    table: 'Items table',
    totals: 'Totals',
    signature: 'Signatures',
    footer: 'Footer notes',
    preview: 'Preview',
  },
  fields: {
    paperSize: 'Paper size',
    logoUrl: 'Logo URL',
    tenCongTy: 'Company name',
    dongDiaChi1: 'Address line 1',
    dongDiaChi2: 'Address line 2',
    hotline: 'Hotline',
    website: 'Website',
    tieuDeHoaDon: 'Template title',
    thongTinTrai: 'Left info column',
    thongTinPhai: 'Right info column',
    cot: 'Table columns',
    cotTieuDe: 'Column header',
    cotHienThi: 'Visible',
    tongTienHangHienThi: 'Show Subtotal',
    chietKhauHienThi: 'Show Discount',
    tongThanhToanHienThi: 'Show Grand total',
    hienThiTongBangChu: 'Show amount in words',
    chuKy: 'Signature boxes',
    chuKyTieuDe: 'Box title',
    chuKyGhiChu: 'Box note',
    ngayThangNamLine: 'Date line',
    ghiChuFooter: 'Footer notes',
    saveMauInName: 'Template name',
    saveMauInNamePlaceholderPdf: 'E.g. Standard A4 invoice',
    saveMauInNamePlaceholderExcel: 'E.g. Accounting Excel invoice',
    saveMauInPrivate: 'Only me',
    saveMauInPublic: 'Shared',
  },
  studio: {
    paper: 'Paper',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    marginTop: 'Top margin (mm)',
    marginRight: 'Right margin (mm)',
    marginBottom: 'Bottom margin (mm)',
    marginLeft: 'Left margin (mm)',
    appearance: 'Table style',
    fontFamily: 'Font',
    tableHeaderBg: 'Header background',
    tableBorder: 'Table border',
    zebra: 'Zebra rows',
    textStyle: 'Text style',
    textColor: 'Text color',
    textSection: {
      title: 'Title',
      header: 'Header',
      tableHeader: 'Column header',
      tableBody: 'Table body',
      signatures: 'Signatures',
      totals: 'Totals',
    },
    totalsRows: 'Visible rows',
    totalsLook: 'Totals layout',
    totalsLayout: 'Borders',
    totalsLayoutGrid: 'Grid',
    totalsLayoutLines: 'Lines',
    totalsLayoutPlain: 'None',
    totalsWidth: 'Width',
    totalsWidthFull: 'Full width',
    totalsWidthRight: '{pct}% right',
    totalsHighlightLast: 'Highlight the last row (grand total)',
    selectedColumns: 'Selected columns',
    addColumn: 'Add column',
    sampleData: 'Sample data',
    viewSheet: 'Preview sheet',
    editSheet: 'Edit template',
    previewSummary: '{rows} rows · {cols} cols',
    blocks: 'Sheet structure',
    addBlock: 'Add block',
    addGroupBasic: 'Basic blocks',
    addGroupTable: 'Table & totals',
    addGroupPreset: 'Quick layouts',
    preset: {
      company: 'Company info',
      signatures: 'Signatures',
      qrCode: 'Document code QR',
      trackingBarcode: 'Tracking number barcode',
    },
    sheetTemplates: {
      open: 'Templates',
      openHint: 'Pick a ready-made layout for the whole sheet — company info, columns and signatures are kept. Ctrl+Z to undo.',
      title: 'Ready-made print templates',
      subtitle: 'Click a template to apply it to the whole sheet. Company info, table columns and signatures are kept.',
      applyHover: 'Use this template',
      applied: 'Applied “{name}”. Press Ctrl+Z to go back.',
      defaultBadge: 'Default',
      khoBadge: 'Warehouse standard',
      items: {
        'kho-pgh-v1': {
          name: 'Delivery note V1',
          desc: 'Warehouse operations sheet: logo + address, tracking code, image · location · pack size, parcel totals, Storekeeper / Carrier / Receiver signatures.',
        },
        'kho-pgh-v1-plain': {
          name: 'Delivery note V1 · no logo',
          desc: 'Delivery note V1 without branch logo and address.',
        },
        'kho-hd-v1': {
          name: 'Sales invoice V1',
          desc: 'Warehouse operations sheet with sale price, amount, grand total + in words, logo + address.',
        },
        'kho-hd-v1-plain': {
          name: 'Sales invoice V1 · no logo',
          desc: 'Sales invoice V1 without branch logo and address.',
        },
        'kho-pgh-v2': {
          name: 'Delivery note V2',
          desc: 'Like V1, plus parcel size (cm) and parcel weight (kg) columns.',
        },
        'kho-pgh-v2-plain': {
          name: 'Delivery note V2 · no logo',
          desc: 'Delivery note V2 without branch logo and address.',
        },
        'kho-hd-v2': {
          name: 'Sales invoice V2',
          desc: 'Sales invoice V1 plus parcel size and parcel weight columns.',
        },
        'kho-hd-v2-plain': {
          name: 'Sales invoice V2 · no logo',
          desc: 'Sales invoice V2 without branch logo and address.',
        },
        'kho-logo': {
          name: 'Warehouse standard · logo',
          desc: 'Like the old warehouse sheets: logo + address, barcode, info box + QR, grey grid table, 3 signatures.',
        },
        'kho-plain': {
          name: 'Warehouse standard · no logo',
          desc: 'Warehouse sheet without logo/address — for pre-printed letterhead paper.',
        },
        'kho-a5': {
          name: 'Compact warehouse · A5',
          desc: 'Compact A5 warehouse sheet: smaller text, document barcode, no QR to fit half an A4.',
        },
        modern: {
          name: 'Modern',
          desc: 'Dark blue accent, large title, table with header fill and zebra rows.',
        },
        classic: {
          name: 'Classic',
          desc: 'Times font, centered header with double rule, ruled totals — accounting style.',
        },
      },
    },
    library: {
      open: 'Block library',
      openHint: 'Pick a ready-made block group (header, footer, signatures…) and tweak it lightly',
      title: 'Ready-made block library',
      subtitle: 'Click a template to add it to the sheet. Text, logo and alignment stay editable like any block.',
      more: 'Browse all ready-made blocks…',
      insert: 'Add',
      insertHover: 'Add to sheet',
      emptyTitle: 'The sheet is empty',
      emptyHint: 'Start fast with ready-made blocks: pick a header, an info section, signatures and a footer.',
      filterLabel: 'Filter:',
      noMatch: 'No blocks match this filter.',
      filter: {
        all: 'All',
        logo: 'With logo',
        noLogo: 'No logo',
        qr: 'With QR',
        tracking: 'Tracking no.',
      },
      tag: {
        logo: 'Logo',
        qr: 'QR',
        barcode: 'Barcode',
        tracking: 'Tracking',
      },
      placement: {
        top: 'At the top',
        bottom: 'At the bottom',
        selected: 'After selected block',
        selectedInside: 'Into selected group',
      },
      category: {
        all: 'All',
        header: 'Header',
        title: 'Title',
        info: 'Information',
        shipping: 'Shipping',
        signature: 'Signatures',
        footer: 'Footer',
      },
      items: {
        'header-logo-left': { name: 'Logo left + info', desc: 'Logo on the left, company name, address and hotline on the right.' },
        'header-big-logo': { name: 'Big logo + address', desc: 'Large logo on the left with a big company name — like the warehouse delivery note.' },
        'header-centered': { name: 'Centered with logo', desc: 'Logo, company name and address centered, with an underline.' },
        'header-company-qr': { name: 'Logo + info + QR', desc: 'Logo, company info and document QR code on the right.' },
        'header-title-meta': { name: 'Logo + title + number', desc: 'Logo, centered title, document number and print date on the right.' },
        'header-text-only': { name: 'Text only (no logo)', desc: 'Company name and address left; number and date right; bold rule.' },
        'header-minimal': { name: 'Minimal one line', desc: 'Company name and hotline on one line with a thin rule.' },
        'header-text-qr': { name: 'Text + QR (no logo)', desc: 'Company info on the left, document QR code on the right.' },
        'title-center': { name: 'Centered title', desc: 'Large title, document number and date line, centered.' },
        'title-meta-row': { name: 'Title + number row', desc: 'Large title with document number left and time right below it.' },
        'title-tracking-meta': { name: 'Title + tracking number', desc: 'Invoice no. · Tracking no. · Time row under the title — warehouse style.' },
        'title-tracking-barcode': { name: 'Tracking barcode + title', desc: 'Tracking barcode on top, then title and Invoice · Tracking · Time row.' },
        'title-barcode': { name: 'Title + document barcode', desc: 'Title and date on the left, document barcode on the right.' },
        'title-qr-right': { name: 'Title + QR', desc: 'Title, number and date on the left; document QR on the right.' },
        'info-two-cols': { name: 'Info in 2 columns (inline)', desc: 'Two columns, value right after the label "Label: value".' },
        'info-aligned-one-col': { name: 'Aligned info', desc: 'Labels in one column, values aligned in another — one field per line.' },
        'info-aligned-two-cols': { name: 'Aligned info, 2 columns', desc: 'Two columns, each with labels and values lined up.' },
        'info-aligned-qr': { name: 'Aligned info + QR', desc: 'Aligned labels / values on the left, document QR on the right.' },
        'info-aligned-recipient': { name: 'Customer | Document', desc: 'Two titled sections: customer and document info, labels aligned.' },
        'info-one-col': { name: 'Info in 1 column (inline)', desc: 'One field per line, value right after the label — good for A5.' },
        'info-boxed': { name: 'Boxed info', desc: 'All info inside one bordered box with bold labels.' },
        'info-boxed-two-cols': { name: 'Boxed info, 2 columns', desc: 'Two bordered boxes side by side, fields split in half.' },
        'info-boxed-qr': { name: 'Boxed info + QR', desc: 'Info box on the left, large QR on the right — warehouse style.' },
        'info-recipient-tracking': { name: 'Recipient + tracking', desc: 'Recipient box (name, phone, address) with tracking barcode on the right.' },
        'ship-tracking-barcode': { name: 'Large tracking barcode', desc: 'Large centered tracking barcode with the number below.' },
        'ship-tracking-qr': { name: 'Tracking barcode + QR', desc: 'Tracking number and barcode left, document QR right.' },
        'ship-label': { name: 'Shipping label', desc: 'Sender / Recipient boxes side by side, tracking barcode below.' },
        'ship-carrier-box': { name: 'Shipping box + tracking QR', desc: 'Tracking no., document no., ship date, delivery note; QR of tracking no.' },
        'signature-screen': { name: 'Screen signatures', desc: 'Default signature boxes of this screen, side by side.' },
        'signature-received': { name: 'Date + Received + signatures', desc: 'Date, a "Received in full" line and signature boxes — warehouse style.' },
        'signature-two': { name: 'Two signatures', desc: 'Prepared by and Customer, with signing hint.' },
        'signature-date-right': { name: 'Date + signature right', desc: 'Date line and preparer signature on the right.' },
        'signature-confirm': { name: 'Confirmation + recipient', desc: 'Goods-checked statement on the left, recipient signature on the right.' },
        'footer-thanks': { name: 'Thank you', desc: 'Dashed line and a centered thank-you note.' },
        'footer-notes': { name: 'Receiving notes', desc: 'Notes on receiving goods / order claims and a closing wish — warehouse style.' },
        'footer-contact': { name: 'Hotline + website', desc: 'Line, hotline on the left and website on the right.' },
        'footer-qr-note': { name: 'QR + note', desc: 'Lookup QR code with a closing note.' },
        'footer-tracking-lookup': { name: 'Tracking lookup + QR', desc: 'Lookup hint, tracking number, hotline and a QR of the tracking number.' },
        'footer-policy': { name: 'Return policy', desc: 'Boxed return policy and print time.' },
      },
    },
    selectBlockHint: 'Select a block to move, duplicate, hide or delete it',
    treeHideBlock: 'Hide block (not printed)',
    treeShowBlock: 'Show block',
    treeCollapseAll: 'Collapse',
    treeExpandAll: 'Expand all',
    treeCollapseGroup: 'Collapse group',
    treeExpandGroup: 'Expand group',
    templates: 'Templates',
    templatesCount: '{count} templates',
    clickToEdit: 'Click the sheet to select a block · click again to edit its content · Delete to remove',
    showStructure: 'Show block structure',
    hideStructure: 'Hide block structure',
    structureHint: 'Dashed outlines and name labels show each block. Turn off to see the clean printed look.',
    blockChip: {
      page: 'Paper',
    },
    undo: 'Undo',
    redo: 'Redo',
    clearAllBlocks: 'Clear all',
    sheet: 'Sheet',
    sheetEmptyHint:
      'Click a cell, drag to select a range, or Shift+click / Shift+arrow to extend. Merge and Unmerge are on the preview bar. Type or insert a variable in the side panel.',
    sheetSelectionOne: 'Selected {cell}',
    sheetSelectionRange: 'Selected {from}:{to}',
    mergeCells: 'Merge',
    mergeCellsHint: 'Drag or Shift+click a range, then merge into one cell',
    unmergeCells: 'Unmerge',
    unmergeCellsHint: 'Select a merged cell, then split it back into cells',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    zoomReset: 'Reset to 100%',
    fitWidth: 'Fit width (larger paper, scroll down)',
    colResizeHint: 'Drag to resize column · Double-click to reset widths',
    fitPage: 'Fit whole page',
    undoShortcut: 'Undo (Ctrl+Z)',
    redoShortcut: 'Redo (Ctrl+Y)',
    saveShortcut: 'Save (Ctrl+S)',
    unsaved: 'Unsaved',
    resetStyle: 'Reset this block style',
    selectAll: 'Select all',
    selectNone: 'Clear all',
    showBlock: 'Show this block',
    blockName: 'Block name',
    infoBlankHint:
      'From a blank sheet: turn on fields below, or add a text / field row to enter content.',
    addInfoText: 'Add text line',
    addInfoFieldRow: 'Add field row',
    addInfoField: 'Add existing field',
    addChildBlock: 'Add child block',
    treeMoveIn: 'Move inside',
    treeMoveOut: 'Move outside',
    treeCopyBlock: 'Duplicate block',
    treeCopySuffix: ' (copy)',
    treeMoveUp: 'Move up',
    treeMoveDown: 'Move down',
    treeDeleteBlock: 'Delete block',
    blockKind: 'Block type',
    childrenLayout: 'Arrange',
    childrenLayoutVertical: 'Vertical',
    childrenLayoutHorizontal: 'Horizontal',
    childrenLayoutHint: 'Child blocks stack vertically by default. Choose Horizontal to place them side by side.',
    childrenWidth: 'Child width (mm)',
    childrenWidthHint: 'Set mm to lock the column. Leave empty to fill remaining space. Logo uses a fixed width × height box.',
    childrenWidthExcel: 'Child width (Excel columns)',
    childrenWidthHintExcel: 'Set how many Excel columns (A, B, C…) this child spans. Leave empty to fill the rest of the row.',
    blockWidthMm: 'Block width (mm)',
    blockWidthCols: 'Block width (columns)',
    excelLayout: 'Excel cell layout',
    excelLayoutHint: 'Set start column (1 = A) and column count. E.g. start 1, count 4 = A→D.',
    excelColStart: 'Start column',
    excelColCount: 'Column count',
    excelColEnd: 'End column',
    excelColEndAuto: 'End of row (auto)',
    excelRowHeightPt: 'Row height',
    excelRowHeightHint: 'Same unit as Excel (Format → Row Height). Leave empty to auto-fit. Excel default ~15.',
    infoNestHint:
      'Select this block, then «Add child block» to nest text / field rows / … inside (YTL-style). Nesting can be multi-level.',
    align: 'Alignment',
    alignLeft: 'Left',
    alignCenter: 'Center',
    alignRight: 'Right',
    bold: 'Bold',
    italic: 'Italic',
    underline: 'Underline',
    fontSize: 'Font size (pt)',
    textContent: 'Content',
    textVarsHint: 'Type fixed text; use Insert variable to add document data.',
    insertVar: 'Insert variable',
    varTextPlaceholder: 'Type text…',
    varGroupCommon: 'General',
    varGroupInfo: 'Document fields',
    varGroupColumns: 'Table columns',
    varGroupExtra: 'Other',
    varDay: 'Day',
    varMonth: 'Month',
    varYear: 'Year',
    varAmountInWords: 'Amount in words',
    textCase: 'Letter case',
    textCaseNone: 'As typed',
    textCaseUpper: 'UPPERCASE',
    textCaseLower: 'lowercase',
    textCaseSentence: 'Sentence case',
    marginTopMm: 'Top spacing (mm)',
    marginBottomMm: 'Bottom spacing (mm)',
    logoWidth: 'Logo width (mm)',
    logoWidthCols: 'Logo width (columns)',
    logoHeight: 'Logo height (mm)',
    logoImage: 'Logo image',
    logoChoose: 'Choose image',
    logoPaste: 'Paste image',
    logoDragDrop: 'Drop an image here',
    logoPasteHint: 'Or paste an image / http(s) link',
    logoFit: 'Logo fit',
    logoFitContain: 'Contain',
    logoFitCover: 'Cover',
    logoFitFill: 'Fill',
    barcodeField: 'Code content',
    barcodeCode: 'Document code',
    qrSizeMm: 'QR size (mm)',
    barcodeHeightMm: 'Barcode height (mm)',
    codeShowText: 'Print text under the code',
    qrHint: 'Scans to the exact content with a phone or scanner. Hidden automatically when the document has no data.',
    barcodeHint:
      'Code 128 barcode — unaccented letters and digits only. Hidden automatically when the invoice has no tracking number yet.',
    todayVar: 'Today',
    fieldKey: 'Data field',
    fieldLabel: 'Row label',
    labelWidthPct: 'Label width (%)',
    valueWidthPct: 'Value width (%)',
    labelWidthMm: 'Label width (mm)',
    labelWidthAuto: 'Auto',
    labelWidthApply: 'Apply to group',
    labelWidthApplyHint:
      'Use the same label width for every labeled line in this group so values line up. Empty = value right after the label.',
    colorNone: 'No color',
    colorCustom: 'Pick another color',
    sectionFrame: 'Border & fill',
    frameNone: 'None',
    frameSolid: 'Solid',
    frameDashed: 'Dashed',
    frameDotted: 'Dotted',
    frameColor: 'Border color',
    fillColor: 'Fill color',
    paddingMm: 'Padding (mm)',
    childGapMm: 'Gap between children (mm)',
    childGapDefault: 'Default',
    childAlign: 'Vertical align',
    childAlignTop: 'Align top',
    childAlignCenter: 'Align middle',
    childAlignBottom: 'Align bottom',
    tableHeaderBgShort: 'Header fill',
    tableBorderShort: 'Table border',
    tableZebraBgShort: 'Zebra rows',
    pageMargins: 'Page margins (mm)',
    marginsLink: 'Same margin on all sides',
    marginsUnlink: 'Set each side separately',
    marginTopShort2: 'Top',
    marginRightShort: 'Right',
    marginBottomShort2: 'Bottom',
    marginLeftShort: 'Left',
    labelWidthCols: 'Label columns',
    labelWidthColsHint: 'Remaining columns in the block are for the value.',
    dividerStyle: 'Style',
    dividerSolid: 'Solid line',
    dividerDashed: 'Dashed line',
    dividerDotted: 'Dotted line',
    dividerSpace: 'Blank space only',
    sectionContent: 'Content',
    sectionArrange: 'Child layout',
    sectionFormat: 'Text format',
    sectionSize: 'Size',
    sectionLayout: 'Position & spacing',
    fontSizeShort: 'Size',
    textCaseShort: 'Case',
    colorShort: 'Color',
    dividerWidthShort: 'Thickness (pt)',
    widthMmShort: 'Width (mm)',
    heightMmShort: 'Height (mm)',
    widthColsShort: 'Width (cols)',
    marginTopShort: 'Top (mm)',
    marginBottomShort: 'Bottom (mm)',
    autoWidth: 'Auto',
    textLabel: 'Label (optional)',
    textBody: 'Text & data variables',
    stylePart_value: 'Variable value style',
    stylePartReset: 'Reset style',
    textLabelPlaceholder: 'E.g. Customer → prints «Customer: …»',
    dividerWidth: 'Divider thickness (pt)',
    dividerColor: 'Divider color',
    spacerHeight: 'Spacer height (mm)',
    noteBorder: 'Draw a box around',
    blockGap: 'Block gap (mm)',
    lineHeight: 'Line height',
    accentColor: 'Accent color',
    tableZebraBg: 'Zebra row color',
    tableCellPadding: 'Cell padding (pt)',
    formulas: 'Formula columns',
    addFormula: 'Add formula column',
    formulaLabel: 'Column name',
    addTerm: 'Add term',
    termOp: 'Operator',
    termKind: 'Source',
    termField: 'Column',
    termNumber: 'Constant',
    termKindField: 'Data column',
    termKindNumber: 'Constant',
    formulaPreview: 'Formula',
    kind: {
      group: 'Block group',
      table: 'Data table',
      totals: 'Totals',
      text: 'Text',
      variable: 'Data variable',
      fieldRow: 'Field row',
      divider: 'Divider',
      spacer: 'Spacer',
      note: 'Boxed note',
      logo: 'Logo',
      barcode: 'Barcode',
      qrcode: 'QR code',
      clone: 'Copy',
    },
    family: {
      text: 'Text / data',
      group: 'Block group',
      logo: 'Logo / image',
      code: 'QR / barcode',
      line: 'Divider / spacer',
      table: 'Data table',
      totals: 'Totals',
    },
    familyHint: {
      text: 'Fixed text, variables, optional label or box',
      group: 'Holds child blocks, vertical or horizontal',
      logo: 'Branch logo or uploaded image',
      code: 'QR / Code 128 from document no., tracking no.…',
      line: 'Horizontal line or blank gap',
      table: 'Line items, drag to resize columns',
      totals: 'Totals, discount, amount in words',
    },
    block: {
      page: 'Paper / margins',
      title: 'Title',
      header: 'Header',
      info: 'Document info',
      table: 'Data table',
      totals: 'Totals',
      date: 'Date line',
      signatures: 'Signatures',
      footer: 'Footer',
    },
  },
  excel: {
    infoRows: 'Info rows',
    showCustomer: 'Customer',
    showInvoiceNo: 'Invoice number',
    showPhone: 'Phone',
    showBranch: 'Branch',
    showAddress: 'Address',
    showSeller: 'Salesperson',
    showNote: 'Note',
    showTotals: 'Totals',
    showAmountInWords: 'Amount in words',
    columnOrder: 'Column order / labels',
    tableHeaderBg: 'Header background',
    columnDetail: 'Column detail',
    columnWidth: 'Width',
    columnHint: 'Width is Excel character units. Drag column edges A, B, C in the preview to resize.',
    resizeHint: 'Drag a column edge to change width',
    emptyPreview: 'No blocks yet — add blocks in the structure panel to preview.',
    fmt: {
      bold: 'Bold (Ctrl+B)',
      italic: 'Italic (Ctrl+I)',
      underline: 'Underline (Ctrl+U)',
      alignLeft: 'Align left',
      alignCenter: 'Center',
      alignRight: 'Align right',
      fontSize: 'Font size',
      textColor: 'Text color',
      fillColor: 'Fill color',
      noTarget: 'Select a cell with content or a table column to format',
      columnOnly: 'Table columns only support bold and alignment',
    },
    formulaBar: {
      readOnly: 'This cell is filled automatically — edit it in the properties panel',
      placeholder: 'Type cell content… use {field} to insert data',
      empty: 'Select a cell to view / edit its content',
    },
    sheet: {
      open: 'Sheet settings',
      title: 'Excel file settings',
      sheetName: 'Sheet name',
      sheetNamePlaceholder: 'Default: {name}',
      fileName: 'File name',
      fileNameHint: 'Use {code} = document code, {ngay} = export date',
      page: 'Page setup',
      paper: 'Paper',
      portrait: 'Portrait',
      landscape: 'Landscape',
      fitWidth: 'Fit all columns on one page',
      repeatHeader: 'Repeat table header on every printed page',
      view: 'View',
      freezeHeader: 'Freeze rows up to the table header',
      gridLines: 'Show Excel gridlines',
      autoFilter: 'AutoFilter on the table header',
      zebra: 'Banded table rows',
      borders: 'Borders',
      bordersTable: 'Table & frames',
      bordersAll: 'All cells',
      bordersNone: 'None',
      numberFormat: 'Number columns',
      numberInt: '1,234',
      numberDec2: '1,234.00',
      numberText: 'Keep as text',
      numberHint: 'Real numbers can be summed / filtered in Excel.',
    },
  },
  copy: {
    title: 'Duplicate / copy print template',
    suffix: 'copy',
    name: 'Copy name',
    targetScreen: 'Target screen',
    sameKindPdf: 'Can only copy to a PDF template of another screen.',
    sameKindExcel: 'Can only copy to an Excel template of another screen.',
    targetProjects: 'Target projects',
    selectAll: 'Select all ({n} projects)',
    current: 'current',
    onlyCurrentProject: 'The copy will be created in the current project.',
    keepPublic: 'The source is shared → the copy is shared too (everyone in the target project can use it).',
    keepPrivate: 'The source is private → the copy is your private template.',
    submit: 'Create {n} copies',
    success: 'Created {n} template copies.',
    skipped: 'Skipped {n} projects you have no access to.',
    needName: 'Enter a name for the copy.',
    needProject: 'Select at least 1 target project.',
    loadProjectsError: 'Could not load the project list.',
    saveError: 'Could not copy the template. Please try again.',
  },
  actions: {
    save: 'Save template',
    resetDefault: 'Reset to default',
    printTest: 'Print test',
    exportExcelTest: 'Export Excel test',
    insertPlaceholder: 'Insert variable',
    addLine: 'Add line',
    removeLine: 'Remove line',
    addChuKy: 'Add signature box',
    removeChuKy: 'Remove signature box',
    mauInCreateNew: 'New template',
    deleteMauIn: 'Delete template',
    copyMauIn: 'Duplicate / copy template',
    saveMauIn: 'Save template',
    updateMauIn: 'Update template',
    saveAs: 'Save as new',
    saveAsHint: 'Keep the current template and save these edits as another template',
    discardChanges: 'Discard changes',
    discardChangesHint: 'Go back to the last saved version. Use Undo (Ctrl+Z) to get changes back.',
    rebuildDefaultLayout: 'Rebuild default layout',
    rebuildDefaultLayoutHint:
      'Replace the whole layout with the standard template for this screen. Not saved until you click Save; Undo (Ctrl+Z) works.',
    discardAndContinue: 'Discard and continue',
  },
  messages: {
    loadError: 'Failed to load print template.',
    saveSuccess: 'Print template saved.',
    saveError: 'Failed to save print template.',
    resetSuccess: 'Reset to default.',
    resetConfirm: 'Reset template to default? All changes will be lost.',
    isDefault: 'Using default template',
    isCustom: 'Customized',
    noMauInPdf: 'No PDF templates yet',
    noMauInExcel: 'No Excel templates yet',
    mauInInvalid: 'Template is invalid or missing configuration',
    mauInPublicBadge: 'Shared',
    mauInReorderHint: 'Drag to reorder — the order is used in the print template list.',
    mauInReorderFailed: 'Could not save the template order. Please try again.',
    mauInDeleteTitle: 'Delete print template',
    mauInDeleteConfirm: 'Delete "{name}"? It will no longer appear in the template list when printing.',
    mauInDeleted: 'Deleted "{name}".',
    mauInDeleteFailed: 'Could not delete the template. Please try again.',
    noEditPermission: 'Your account lacks the "Edit print templates" permission — view and test print only.',
    mauInKindTitle: 'File type',
    mauInListTitle: 'Saved templates ({count})',
    mauInDraftNew: 'New template (unsaved)',
    saveMauInNameRequired: 'Enter a template name',
    saveMauInSuccess: 'Template saved to the server',
    updateMauInSuccess: 'Template updated',
    selectMauInRequired: 'Select a template before exporting',
    unsavedTitle: 'Template not saved',
    unsavedConfirm: 'You have unsaved changes. They will be lost if you continue.',
  },
  placeholders: {
    help:
      'Use {Variable_Name} to insert dynamic data. E.g: {Ma_Don_Hang}, {Khach_Hang}, {Tong_Cong}.',
  },
  v2: {
    pageBreak: 'Page break',
    hints: {
      lineVarOutsideRepeat: 'Cannot insert: line item fields must be inside a table row marked "Repeat per item". Put the cursor in that row and try again.',
      totalVarOutsideRepeat: 'Cannot insert: total fields must be inside a table row marked "Repeat per total". Put the cursor in that row and try again.',
      groupVarOutsideRepeat:
        'Cannot insert: repair-item fields must be inside a "Repeat per repair item" block. Put the cursor in that block and try again.',
    },
    messages: {
      uploadError: 'Image upload failed',
    },
    canvas: {
      showSample: 'Show sample data',
    },
    toolbar: {
      undo: 'Undo (Ctrl+Z)',
      redo: 'Redo (Ctrl+Y)',
      block: 'Paragraph style',
      blockNormal: 'Normal text',
      blockH1: 'Heading 1',
      blockH2: 'Heading 2',
      blockH3: 'Heading 3',
      font: 'Font',
      fontDefault: 'Default',
      fontSize: 'Font size (pt)',
      bold: 'Bold (Ctrl+B)',
      italic: 'Italic (Ctrl+I)',
      underline: 'Underline (Ctrl+U)',
      strike: 'Strikethrough',
      color: 'Text color',
      highlight: 'Highlight color',
      clearColor: 'No color',
      clearFormat: 'Clear formatting',
      align: {
        left: 'Align left',
        center: 'Center',
        right: 'Align right',
        justify: 'Justify',
      },
      bulletList: 'Bulleted list',
      orderedList: 'Numbered list',
      insert: 'Insert',
      table: 'Table',
      linesTable: 'Items table',
      linesTableHint: 'Insert an items table: header row + a row repeated per item',
      repairGroups: 'Repair item block',
      repairGroupsHint:
        'Insert a block repeated per repair item (1 invoice → many items), each with a spare-parts / service table',
      totalsTable: 'Totals table',
      totalsTableHint: 'Insert a totals table (repeats per total line)',
      signatures: 'Signatures',
      logo: 'Logo',
      logoHint: 'Insert branch logo — filled with the branch logo when printing',
      image: 'Image',
      uploading: 'Uploading…',
      qr: 'QR code',
      barcode: 'Barcode',
      hr: 'Horizontal line',
      pageBreak: 'Page break',
    },
    table: {
      title: 'Table',
      rowAbove: 'Insert row above',
      rowBelow: 'Insert row below',
      colLeft: 'Insert column left',
      colRight: 'Insert column right',
      addRow: 'Row',
      addCol: 'Column',
      above: 'Above',
      below: 'Below',
      left: 'Left',
      right: 'Right',
      headerRow: 'Header',
      delete: 'Delete',
      merge: 'Merge cells',
      split: 'Split cell',
      deleteRow: 'Delete row',
      deleteCol: 'Delete column',
      deleteTable: 'Delete table',
      borders: 'Borders',
      bordersAll: 'Solid',
      bordersDashed: 'Dashed',
      bordersNone: 'None',
      repeat: 'This row',
      repeatNone: 'Normal row',
      repeatLines: 'Repeat per item',
      repeatTotals: 'Repeat per total line',
      repeatHint: 'Repeating rows are duplicated when printing — one row per item (or per total line). Put "Line item" fields in this row.',
      vAlign: 'Vertical align',
      vTop: 'Top',
      vMiddle: 'Middle',
      vBottom: 'Bottom',
      cellBg: 'Cell fill',
      toggleHeaderRow: 'Toggle header row',
      resizeHint: 'Drag a vertical border to resize columns (table width stays the same), double-click to even out the two columns. Select several cells to merge.',
    },
    vars: {
      title: 'Data fields',
      hint: 'Click to insert at the cursor, or drag onto the page.',
      search: 'Search fields…',
      groups: {
        info: 'Voucher info',
        general: 'General',
        line: 'Line item',
        total: 'Total line',
      },
      sections: {
        group: 'Repair items (group)',
        line: 'Spare parts / services (per line)',
        voucher: 'Voucher info',
        customer: 'Customer',
        staff: 'Store & staff',
        money: 'Amounts & payment',
        delivery: 'Delivery & packing',
        repair: 'Repair request',
        code: 'Tracking code / QR',
        general: 'Date & general',
        total: 'Total lines',
      },
      groupHints: {
        group: 'Place inside a "Repeat per repair item" block (1 invoice → many repair items).',
        line: 'Place inside a "Repeat per item" table row (many spare parts under each repair item).',
        total: 'Place inside a "Repeat per total line" table row.',
      },
    },
    props: {
      qrTitle: 'QR code',
      barcodeTitle: 'Barcode',
      codeType: 'Code type',
      codeSource: 'Data',
      codeCustom: 'Custom…',
      codeCustomPlaceholder: 'E.g. {code} or https://…',
      codeCustomHelp: 'Mix text and fields, e.g. https://shop.com/order/{code}',
      qrSize: 'Size',
      barcodeHeight: 'Height',
      barcodeWidth: 'Width',
      auto: 'Auto',
      codeShowText: 'Show text below code',
      resizeHint: 'Drag the corner / edge handles to resize.',
      logoTitle: 'Branch logo',
      imageTitle: 'Image',
      imageWidth: 'Width',
      logoHint: 'The branch logo is filled in automatically when printing (Settings → Print logo).',
    },
    page: {
      title: 'Page',
      paper: 'Paper size',
      orientation: 'Orientation',
      portrait: 'Portrait',
      landscape: 'Landscape',
      margins: 'Margins',
      top: 'Top',
      bottom: 'Bottom',
      left: 'Left',
      right: 'Right',
      font: 'Default font',
      fontSize: 'Font size',
      lineHeight: 'Line spacing',
      soBan: 'Copies',
      soBanUnit: 'pcs',
      soBanHint: 'Each print outputs all copies; every copy starts on a new page.',
      soTrang: 'Page numbers',
      soTrangNone: 'None',
      soTrangLeft: 'Footer · left',
      soTrangCenter: 'Footer · center',
      soTrangRight: 'Footer · right',
      soTrangHint: '"Page x/y" sits in the bottom margin — keep it at 10 mm or more.',
    },
  },
  xv2: {
    exporting: 'Exporting…',
    formula: {
      placeholder: 'Cell content — type text, insert variables like {code}, start with = to calculate (e.g. ={tongCong}+{thuKhac})',
      help:
        'Formula: start the cell with = (e.g. =4+5+6 → 15, ={tongCong}-{giamGia}) or insert {= ... } inside text.\n' +
        'Operators: + - * / ^ %, join text with & (e.g. ={customer} & " - " & {phone}), compare = <> < > <= >=.\n' +
        'Functions: SUM, ROUND, ROUNDUP, ROUNDDOWN, MIN, MAX, ABS, AVERAGE, IF, AND, OR, NOT, CONCAT, UPPER, LOWER, TRIM, LEN, LEFT, RIGHT, TEXT(x; decimals), BANGCHU(x).\n' +
        'Variables do not need to be placed in any cell. Turn on "Show sample data" to see results; invalid formulas show #LỖI.',
    },
    hints: {
      lineVarOutsideRepeat: 'Cannot insert: line variables must be in a row set to "Repeat per item" (right-click → Repeat row).',
      totalVarOutsideRepeat: 'Cannot insert: total variables must be in a row set to "Repeat per total" (right-click → Repeat row).',
    },
    messages: {
      exportError: 'Failed to export Excel file',
      imagesMissing: 'Could not load {n} logo/image(s) (the server image proxy did not respond) — the Excel file was exported without them.',
    },
    toolbar: {
      fill: 'Fill color',
      v: {
        top: 'Align top',
        middle: 'Align middle',
        bottom: 'Align bottom',
      },
      wrap: 'Wrap text',
      borderOn: 'Add borders',
      borderOff: 'Remove borders',
      merge: 'Merge',
      mergeHint: 'Merge the selected cells into one',
      unmerge: 'Unmerge cells',
      linesTableHint: 'Insert the items table at the selected cell: header row + a row repeated per item',
      totalsRow: 'Totals row',
      totalsRowHint: 'Insert a totals row (repeated per total line of the voucher)',
      rowRepeat: 'Row',
      rowRepeatHint: 'Repeat rows are duplicated on export — one row per item / per total line',
    },
    vars: {
      colField: 'Field',
      colSample: 'Sample',
      empty: 'No matching fields',
      groupHints: {
        line: 'Place in a "Repeat per item" row.',
        total: 'Place in a "Repeat per total line" row.',
      },
    },
    grid: {
      insertRowAbove: 'Insert {n} row(s) above',
      insertRowBelow: 'Insert {n} row(s) below',
      insertColLeft: 'Insert {n} column(s) left',
      insertColRight: 'Insert {n} column(s) right',
      deleteRows: 'Delete {n} row(s)',
      deleteCols: 'Delete {n} column(s)',
      merge: 'Merge cells',
      unmerge: 'Unmerge cells',
      clear: 'Clear contents',
      repeatLines: 'Repeat row per item',
      repeatTotals: 'Repeat row per total line',
      repeatNone: 'Remove repeat',
      repeatLinesHint: 'Repeats per item — one row per item on export',
      repeatTotalsHint: 'Repeats per total line — one row per total line on export',
      logoPlaceholder: 'LOGO',
      widthBadge: 'Width: {w} ({px} px)',
      heightBadge: 'Height: {h} pt ({px} px)',
      colGripHint: 'Drag to resize the column · double-click to fit content',
      rowGripHint: 'Drag to resize the row · double-click to reset',
    },
    props: {
      width: 'Width',
      height: 'Height',
      objectHint: 'Anchored at cell {cell}. Drag to move, drag the corner / edge handles to resize, arrow keys to nudge.',
      replaceImage: 'Replace image',
      deleteObject: 'Delete',
    },
    cell: {
      title: 'Cell {range}',
      repeatHint: 'Repeat rows are duplicated on export — put "Item line" / "Total line" variables in this row.',
      colWidth: 'Column width',
      rowHeight: 'Row height',
      hint: 'Double-click or start typing to edit · Enter / Tab to move · Alt+Enter for a new line · right-click to insert / delete rows and columns.',
    },
    sheet: {
      title: 'Sheet',
      sheetName: 'Sheet name',
      fileName: 'File name',
      fileNameHint: 'Supports {code} (voucher code), {ngay} (export date).',
      groupFile: 'Export file',
      groupPage: 'Page',
      groupFont: 'Default font',
      fitWidth: 'Fit to 1 page wide',
      gridLines: 'Show gridlines in Excel',
      freezeRows: 'Freeze top rows',
    },
  },
  formulaDialog: {
    title: 'Build formula',
    open: 'Formula',
    openHint: 'Build a formula to add numbers / join text from variables (with live result)',
    editHint: 'Editing the formula of the selected cell / text',
    vars: 'Variables',
    varsHint: 'Click to insert at the cursor in the formula.',
    search: 'Search variables…',
    operators: 'Operators',
    functions: 'Common functions',
    formula: 'Formula',
    placeholder: 'E.g. {tongCong} + {thuKhac}   or   {customer} & " - " & {phone}',
    readable: 'Reads as',
    result: 'Result with sample data',
    resultEmpty: 'Pick variables and operators above to start',
    resultBlank: '(empty)',
    error: 'Error',
    insertAsExcel: 'Will be written to the cell',
    insertAsPdf: 'Will be inserted into the template',
    examples: 'Examples (click to use)',
    exampleLabels: {
      add: 'Add 2 numbers',
      mul: '10 percent',
      join: 'Join 2 texts',
      bangchu: 'Amount in words',
    },
    ops: {
      add: 'Add numbers. If one side is text, joins text',
      addShort: 'Add',
      sub: 'Subtract',
      subShort: 'Subtract',
      mul: 'Multiply (10% = 0.1)',
      mulShort: 'Multiply',
      div: 'Divide',
      divShort: 'Divide',
      paren: 'Parentheses — evaluated first',
      parenShort: 'Parens',
      join: 'Join text: put values side by side, never adds numbers',
      joinShort: 'Join',
      space: 'Join with a space in between',
      spaceShort: 'Join + space',
      text: 'Fixed text — type between the quotes',
      textShort: 'Text',
    },
    fns: {
      sum: 'SUM(a; b; …) — sum of numbers',
      round: 'ROUND(number; decimals) — round',
      if: 'IF(condition; when true; when false) — e.g. IF({giamGia} > 0; "Discount"; "")',
      text: 'TEXT(number; decimals) — number with thousand separators',
      bangchu: 'BANGCHU(number) — amount in Vietnamese words',
      upper: 'UPPER(text) — uppercase',
    },
    help:
      '• + − × ÷ for numbers; & joins text (keeps "0123" as is, never adds).\n' +
      '• Put fixed text in quotes: "Total: " & {tongCong}.\n' +
      '• Thousands: 1000 or 1.000; decimals: 1.5. Separate function arguments with ; or ,\n' +
      '• Excel: the whole cell becomes =formula. PDF: inserts {= formula } into the text, use "Preview" to see the result.',
    cancel: 'Cancel',
    apply: 'Insert formula',
  },
}
